import { CoreSetupAuditTrailViewsName } from './name';
import { patchSetupAuditTrailViews } from '@api';
import { SetupAuditTrailView } from '@types';
import { updateCoreSetupAuditTrailViewsSyncSlice } from './update';

import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const patchCoreSetupAuditTrailViewsSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => {
				const { viewId, ...rest } = request;
				const update: Partial<SetupAuditTrailView> = {
					id: viewId,
					...rest
				};

				return updateCoreSetupAuditTrailViewsSyncSlice.syncActionCreator(update);
			}
		]
	},
	name: CoreSetupAuditTrailViewsName,
	receive: false,
	request: true,
	requestHandler: patchSetupAuditTrailViews,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Latest
});
